import { render, staticRenderFns } from "./AdsterraBanner.vue?vue&type=template&id=92264010&scoped=true"
import script from "./AdsterraBanner.vue?vue&type=script&lang=js"
export * from "./AdsterraBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsterraBanner.vue?vue&type=style&index=0&id=92264010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92264010",
  null
  
)

export default component.exports